import { format, parseISO } from 'date-fns';
import { useEffect, useRef } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ConnectedFacility, ClearanceStatusEnum } from '../../../api';
import { ClearanceBadge } from '../ClearanceBadge';
import { ConnectionRequestCard } from './ConnectionRequestCard';

export const ReviewConnectionDialog = ({
  connectionRequest,
  show,
  onSubmit,
  closeDialog,
  onAccept,
  onReject,
  onCancel,
  openedFromProfile = false,
  needsContractSigned,
  onOpenContractModal,
}: {
  connectionRequest: ConnectedFacility;
  show: boolean;
  onSubmit: (connectionRequest: ConnectedFacility) => void;
  closeDialog: (result: boolean) => void;
  onAccept: (connectionRequest: ConnectedFacility) => void;
  onReject: (connectionRequest: ConnectedFacility) => void;
  onCancel: (connectionRequest: ConnectedFacility) => void;
  openedFromProfile?: boolean;
  needsContractSigned?: boolean;
  onOpenContractModal?: () => void;
}) => {
  const { handleSubmit, reset } = useForm();
  const formEl = useRef<HTMLFormElement>(null);

  useEffect(() => {
    reset({ facility: connectionRequest.facility.id });
  }, [connectionRequest, reset]);

  const onSubmitHandler = (data) => {
    onSubmit(data);
  };

  return (
    <Form ref={formEl} noValidate onSubmit={handleSubmit(onSubmitHandler)}>
      <Modal show={show} onHide={() => closeDialog(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <span>Facility Connection Request</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
          <ConnectionRequestCard
            connectionRequest={connectionRequest}
            onAccept={onAccept}
            onReject={onReject}
            onCancel={onCancel}
            needsContractSigned={needsContractSigned}
            onOpenContractModal={onOpenContractModal}
            openedFromProfile={openedFromProfile}
          />
        </Modal.Body>
      </Modal>
    </Form>
  );
};
